import React, { Component } from "react";
import PropTypes from "prop-types";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// style
import "./Autocomplete.scss";

/**
 * @example
 *          <Autocomplete suggestions={["Oranges", "Apples", "Banana", "Kiwi", "Mango"]} />
 */
class Autocomplete extends Component {
    static propTypes = {
        suggestions: PropTypes.instanceOf(Array)
    };

    static defaultProps = {
        suggestions: []
    };

    constructor(props) {
        super(props);

        this.state = {
            // The active selection's index
            activeSuggestion: 0,
            // The suggestions that match the user's input
            filteredSuggestions: [],
            // Whether or not the suggestion list is shown
            showSuggestions: false,
            // What the user has entered
            userInput: ""
        };

        // console.log(this.props.onClick);
    }

    onChange = e => {
        const { suggestions } = this.props;
        const userInput = e.currentTarget.value;

        // Filter our suggestions that don't contain the user's input
        const filteredSuggestions = suggestions.filter(
            suggestion =>
                suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        this.setState({
            activeSuggestion: 0,
            filteredSuggestions,
            showSuggestions: true,
            userInput: e.currentTarget.value
        });
    };

    onClick = e => {
        this.setState({
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: false,
            userInput: e.currentTarget.innerText
        });
    };

    onKeyDown = e => {
        const { activeSuggestion, filteredSuggestions } = this.state;

        // User pressed the enter key
        if (e.keyCode === 13) {
            this.setState({
                activeSuggestion: 0,
                showSuggestions: false,
                userInput: filteredSuggestions[activeSuggestion]
            });
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion - 1 });
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === filteredSuggestions.length) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion + 1 });
        }
    };

    // ____________________________________ check ____________________________________

    isButtonDisabled(value) {
        if (value.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    // ____________________________________ onHandlers ____________________________________

    onClickHandler(e) {
        console.log('check onClick - e: ' + e);
        this.props.onClick(e);
        console.log('check onApplyClick  - e: ' + e);
        this.props.onApplyClick(e, this.props.selectedState, e);
    }

    // ____________________________________ render ____________________________________

    render() {
        const {
            onChange,
            onClick,
            onKeyDown,
            state: {
                activeSuggestion,
                filteredSuggestions,
                showSuggestions,
                userInput
            }
        } = this;

        let suggestionsListComponent;

        if (showSuggestions && userInput) {
            if (filteredSuggestions.length) {
                suggestionsListComponent = (
                    <ul className="suggestions">
                        {filteredSuggestions.map((suggestion, index) => {
                            let className;

                            // Flag the active suggestion with a class
                            if (index === activeSuggestion) {
                                className = "suggestion-active";
                            }

                            return (
                                <li className={className} key={suggestion} onClick={onClick}>
                                    {suggestion}
                                </li>
                            );
                        })}
                    </ul>
                );
            } else {
                suggestionsListComponent = (
                    <div className="no-suggestions">
                        <p className="small">{i18n.t('select.artisttitle.nosuggestion')}</p>
                    </div>
                );
            }
        }

        return (
            <div className="autocomplete-wrapper">

                <div className="input-group">
                    <i className="icon"></i>
                    <input
                        type="text"
                        className="form-control"
                        placeholder={i18n.t('select.artisttitle.placeholder')}
                        aria-label={i18n.t('select.artisttitle.placeholder')}
                        aria-describedby="button-addon2"

                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        value={userInput}
                    />
                    <div className="input-group-append">
                        <button className="btn btn-outline-secondary btn-outline-secondary-ing"
                            type="button"
                            id="button-addon2"
                            // onClick={(e) => this.props.onClick(userInput)}
                            onClick={(e) => this.onClickHandler(userInput)}
                            disabled={this.isButtonDisabled(userInput)}
                        >{i18n.t('select.artisttitle.search')}</button>
                    </div>
                </div>

                {suggestionsListComponent}
            </div>
        );
    }
}

export default withTranslation()(Autocomplete);
